import {useTranslation} from "react-i18next";

import type {ApiQueryError} from "../redux/types";
import I18nErrorMessage from "./I18nErrorMessage";

export interface ImmodropErrorMessageProps {
    /** Fehler aus dem Exposé-Import (URL-Scan oder PDF-Upload), oder null */
    error?: ApiQueryError | null;
}

/**
 * Fehlermeldung des Exposé-Imports: die übersetzte Erklärung zum Statuscode plus — falls vorhanden —
 * die Klartextmeldung des Auswertungsdienstes als zweite Zeile (#19159).
 *
 * Warum die Dienstmeldung sichtbar sein soll: sie ist die einzige Stelle, an der die konkrete Ursache
 * steht ("KI Extractor kann keine Werte extrahieren"). Ohne sie bleibt im Support nur das
 * Container-Log. Sie ist bewusst der Erklärung nachgeordnet und nicht übersetzt, weil sie wörtlich
 * vom Dienst kommt.
 */
export default function ImmodropErrorMessage({error}: ImmodropErrorMessageProps) {
    const {t} = useTranslation();
    const serviceMessage = (error?.errorArgs as {serviceMessage?: string | null} | null)?.serviceMessage;

    return (
        <I18nErrorMessage
            errorObject={error}
            contentAfterMessage={
                serviceMessage ? (
                    <div className="text-sm text-color-secondary mt-1 mb-2">
                        {t("importDialog.immodrop.error.serviceMessage", {serviceMessage})}
                    </div>
                ) : undefined
            }
        />
    );
}
